import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { pushItemsToCart, resetCart } from "store/actions/cart.action";

//Controllers for cart.
function useCart() {
  const currentCartItems = useSelector((state) => state.cartReducer.items);

  const dispatch = useDispatch();

  //Store next items in redux.
  const dispatchItemsToCart = function (nextItemsInCart) {
    dispatch(pushItemsToCart(nextItemsInCart));
  };

  //Returns total price of cart
  const cartTotalPrice = currentCartItems.reduce(
    (accumulator, { item, quantity }) => {
      return accumulator + item.val * quantity;
    },
    0
  );

  //Returns sum of quantities of every item in cart
  const cartTotalQuantities = currentCartItems.reduce(
    (accumulator, { item, quantity }) => {
      return accumulator + quantity;
    },
    0
  );

  const clearCart = () => dispatch(resetCart());

  const totalDiscountPrice = currentCartItems.reduce(
    (accumulator, { discount }) => {
      return accumulator + discount;
    },
    0
  );

  const validateCartItems = (validateApiResponse) => {
    let itemsUnableToDispense = null;
    //All items are validated.
    if (validateApiResponse.invalidItems.length === currentCartItems.length) {
      //It means all items are invalidated so, reset the cart.
      itemsUnableToDispense = [];
      //Set timeout prevents redirection of page to home as there are no items available.
      setTimeout(() => {
        clearCart();
      }, 0);
    } else if (validateApiResponse.invalidItems.length > 0) {
      itemsUnableToDispense = [];
      //Get invalid items id
      let invalidProductIds = validateApiResponse.invalidItems.map(
        (ele) => ele.product_id
      );

      //Manipulates cart items
      let nextCartItems = currentCartItems.filter((element) => {
        if (invalidProductIds.includes(element.item.sid)) {
          itemsUnableToDispense.push(element.item.name);
          return false;
        }
        return true;
      });

      dispatchItemsToCart(nextCartItems);
    }

    return itemsUnableToDispense;
  };

  return {
    currentCartItems,
    cartTotalPrice,
    cartTotalQuantities,
    clearCart,
    totalDiscountPrice,
    validateCartItems,
  };
}

export default useCart;
